import { darken, lighten } from '@mui/material';

const getEditorSx = (theme) => ({
	'& .tiptap': {
		outline: 'none',
		border: 'none',
		whiteSpace: 'pre-wrap',
		tabSize: 4,

		'&:first-of-type': { marginTop: 0 },

		'& p': {
			marginBlockStart: 0,
			marginBlockEnd: 0,
		},

		'& img': {
			display: 'block',
		},

		'& [data-resize-handle]': {
			display: 'none',
		},

		'& .ProseMirror-selectednode [data-resize-handle]': {
			display: 'block',
			position: 'absolute',
			background: 'rgba(0, 0, 0, 0.5)',
			border: '1px solid rgba(255, 255, 255, 0.8)',
			borderRadius: '2px',
			zIndex: 10,

			'&:hover': {
				background: 'rgba(0, 0, 0, 0.8)',
			},

			/* Corner handles */
			"&[data-resize-handle='top-left'], &[data-resize-handle='top-right'], &[data-resize-handle='bottom-left'], &[data-resize-handle='bottom-right']":
				{
					width: '8px',
					height: '8px',
				},

			"&[data-resize-handle='top-left']": {
				top: '-4px',
				left: '-4px',
				cursor: 'nwse-resize',
			},
			"&[data-resize-handle='top-right']": {
				top: '-4px',
				right: '-4px',
				cursor: 'nesw-resize',
			},
			"&[data-resize-handle='bottom-left']": {
				bottom: '-4px',
				left: '-4px',
				cursor: 'nesw-resize',
			},
			"&[data-resize-handle='bottom-right']": {
				bottom: '-4px',
				right: '-4px',
				cursor: 'nwse-resize',
			},

			/* Edge handles */
			"&[data-resize-handle='top'], &[data-resize-handle='bottom']": {
				height: '6px',
				left: '8px',
				right: '8px',
			},
			"&[data-resize-handle='top']": {
				top: '-3px',
				cursor: 'ns-resize',
			},
			"&[data-resize-handle='bottom']": {
				bottom: '-3px',
				cursor: 'ns-resize',
			},

			"&[data-resize-handle='left'], &[data-resize-handle='right']": {
				width: '6px',
				top: '8px',
				bottom: '8px',
			},
			"&[data-resize-handle='left']": {
				left: '-3px',
				cursor: 'ew-resize',
			},
			"&[data-resize-handle='right']": {
				right: '-3px',
				cursor: 'ew-resize',
			},
		},

		// The outline around the selected wrapper
		'& .ProseMirror-selectednode [data-resize-wrapper]': {
			outline: '1px solid rgba(0, 0, 0, 0.25)',
			borderRadius: '0.125rem',
		},

		'& .template-value-chip': {
			backgroundColor: lighten(theme.palette.primary.main, 0.85),
			color: darken(theme.palette.primary.main, 0.2),
			borderRadius: '0.4rem',
			boxDecorationBreak: 'clone',
			padding: '0.1rem 0.3rem',
			position: 'relative',
			'&:hover': {
				backgroundColor: lighten(theme.palette.primary.main, 0.95),
				color: darken(theme.palette.primary.main, 0.1),
			},
			'&::after': {
				content: "' '",
			},

			'&:hover::before': {
				content: 'var(--template-tooltip-label)',
				position: 'absolute',
				whiteSpace: 'nowrap',
				background: 'rgba(0, 0, 0, 0.85)',
				color: '#fff',
				padding: '4px 8px',
				borderRadius: '4px',
				fontSize: '0.75rem',
				top: '-28px',
				left: '50%',
				transform: 'translateX(-50%)',
				pointerEvents: 'none',
				zIndex: 9999,
			},

			'&:hover::after': {
				content: '" "',
			},
		},

		'& [data-readonly="true"]': {
			userSelect: 'text',
		},

		'& [data-readonly="true"] *': {
			pointerEvents: 'none',
		},

		'& .template-value-editable-chip': {
			borderRadius: '0.4rem',
			boxDecorationBreak: 'clone',
			padding: '0.1rem 0.3rem',
			position: 'relative',
			border: `1px dashed ${lighten(theme.palette.primary.main, 0.75)}`,
			'&:hover': {
				border: `1px dashed ${lighten(theme.palette.primary.main, 0.25)}`,
			},
			'&::after': {
				content: "' '",
			},

			'&:hover::before': {
				content: 'var(--template-tooltip-label)',
				position: 'absolute',
				whiteSpace: 'nowrap',
				background: 'rgba(0, 0, 0, 0.85)',
				color: '#fff',
				padding: '4px 8px',
				borderRadius: '4px',
				fontSize: '0.75rem',
				top: '-28px',
				left: '50%',
				transform: 'translateX(-50%)',
				pointerEvents: 'none',
				zIndex: 9999,
			},

			'&:hover::after': {
				content: '" "',
			},
		},

		// '& td': {
		// 	borderRight: '0.5px dotted lightgrey',
		// },
		// '& th': {
		// 	borderRight: '0.5px dotted lightgrey',
		// 	borderBottom: '2px solid rgb(230, 233, 242) !important',
		// 	fontWeight: 'normal',
		// 	textAlign: 'left',
		// },

		'& th': {
			fontWeight: 'normal',
			textAlign: 'left',
			'&:hover': {
				boxShadow: `0 0 0 1.5px ${lighten(theme.palette.primary.main, 0.85)}`,
			},
		},
		'& td': {
			'&:hover': {
				boxShadow: `0 0 0 1.5px ${lighten(theme.palette.primary.main, 0.85)}`,
			},
		},

		// '& tr:last-child td': {
		// 	borderBottom: '0 !important',
		// },
		// '& .selectedCell': {
		// 	boxShadow: `0 0 0 1.5px ${lighten(palette.folioBlue, 0.75)}`,
		// },
		'& td.selectedCell, & td:has(.has-focus)': {
			backgroundColor: lighten(theme.palette.primary.main, 0.9),
			boxShadow: `0 0 0 1.5px ${lighten(theme.palette.primary.main, 0.75)}`,
		},
		'& th.selectedCell, & th:has(.has-focus)': {
			backgroundColor: lighten(theme.palette.primary.main, 0.9),
			boxShadow: `0 0 0 1.5px ${lighten(theme.palette.primary.main, 0.75)}`,
		},
		// '& .editor-selection': {
		// 	boxShadow: `0 0 0 1.5px ${lighten(palette.folioBlue, 0.75)}`,
		// },
		// '& .has-focus': {
		// 	boxShadow: `0 0 0 0.5px ${lighten(palette.folioBlue, 0.75)}`,
		// },

		'& .tableWrapper': {
			margin: '1.5rem 0',
			overflowX: 'auto',
		},

		'&.resize-cursor': {
			cursor: 'ew-resize',
			// eslint-disable-next-line no-dupe-keys
			cursor: 'col-resize',
		},
	},
});

export default getEditorSx;
